import { SharedMaterialsState } from "./interfaces";

const initialSharedMaterialsState: SharedMaterialsState = {
    materials: []
};

export default initialSharedMaterialsState;
